import { PersistConfig } from 'redux-persist';
import { CookieStorage, CookiesAdapter } from 'redux-persist-cookie-storage';
import { StateFromReducersMapObject } from 'redux';
import { catalogItemViewReducerPath } from 'src/features/catalogItem/view';
import { uxReducerPath } from 'src/shared/ux';
import { reducerConfig } from './slices';

interface ReduxPersistConfigCreatorOptions {
  cookiesAdapter: CookiesAdapter;
}

interface ReduxPersistConfigCreator {
  (options: ReduxPersistConfigCreatorOptions): PersistConfig<StateFromReducersMapObject<typeof reducerConfig>>;
}

export const createReduxPersistConfig: ReduxPersistConfigCreator = ({ cookiesAdapter }) => ({
  key: 'root',
  storage: new CookieStorage(cookiesAdapter),
  stateReconciler(inboundState, originalState) {
    // Always use originalState:
    // 1. Server - state manually loaded from cookies
    // 2. Client - state rehydrated from window.__APP_PRELOADED_STATE__ object (cookies not used)
    return originalState;
  },
  // Here should be added names of preserved redux store slices
  whitelist: ['persistance', catalogItemViewReducerPath, 'theme', 'agreements', uxReducerPath],
});
